// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Impersonation Banner ─────────────────────────────────────── */
.impersonation-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2000;
  background: linear-gradient(90deg, #b45309 0%, #d97706 50%, #b45309 100%);
  background-size: 200% 100%;
  animation: banner-shimmer 4s ease-in-out infinite;
  box-shadow: 0 2px 8px rgba(180, 83, 9, 0.45);
  height: 44px;
  display: flex;
  align-items: center;
}

@keyframes banner-shimmer {
  0%   { background-position: 0% 50%; }
  50%  { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.impersonation-banner__inner {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.impersonation-banner__left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
}

.impersonation-banner__icon {
  display: flex;
  align-items: center;
  color: #fff;
  flex-shrink: 0;
}

.impersonation-banner__badge {
  background: rgba(255, 255, 255, 0.22);
  border: 1px solid rgba(255, 255, 255, 0.35);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 20px;
  white-space: nowrap;
  flex-shrink: 0;
}

.impersonation-banner__divider {
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, 0.35);
  flex-shrink: 0;
}

.impersonation-banner__eye {
  color: rgba(255, 255, 255, 0.85);
  flex-shrink: 0;
}

.impersonation-banner__label {
  color: #fff;
  font-size: 13px;
  font-weight: 400;
  white-space: nowrap;
  flex-shrink: 0;
}

.impersonation-banner__name {
  font-weight: 700;
  color: #fef3c7;
}

.impersonation-banner__note {
  color: rgba(255, 255, 255, 0.75);
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.impersonation-banner__back-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.45);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  padding: 5px 14px;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.15s ease, transform 0.1s ease;
}

.impersonation-banner__back-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.28);
  transform: translateY(-1px);
}

.impersonation-banner__back-btn:active:not(:disabled) {
  transform: translateY(0);
}

.impersonation-banner__back-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

/* Mobile: hide the note text */
@media (max-width: 640px) {
  .impersonation-banner__note {
    display: none;
  }
  .impersonation-banner__back-btn span {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ImpersonationBanner/ImpersonationBanner.css"],"names":[],"mappings":"AAAA,oEAAoE;AACpE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,yEAAyE;EACzE,0BAA0B;EAC1B,iDAAiD;EACjD,4CAA4C;EAC5C,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,6BAA6B,EAAE;EACtC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,2CAA2C;EAC3C,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,sDAAsD;AACxD;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ── Impersonation Banner ─────────────────────────────────────── */\n.impersonation-banner {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 2000;\n  background: linear-gradient(90deg, #b45309 0%, #d97706 50%, #b45309 100%);\n  background-size: 200% 100%;\n  animation: banner-shimmer 4s ease-in-out infinite;\n  box-shadow: 0 2px 8px rgba(180, 83, 9, 0.45);\n  height: 44px;\n  display: flex;\n  align-items: center;\n}\n\n@keyframes banner-shimmer {\n  0%   { background-position: 0% 50%; }\n  50%  { background-position: 100% 50%; }\n  100% { background-position: 0% 50%; }\n}\n\n.impersonation-banner__inner {\n  width: 100%;\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 0 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.impersonation-banner__left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.impersonation-banner__icon {\n  display: flex;\n  align-items: center;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.impersonation-banner__badge {\n  background: rgba(255, 255, 255, 0.22);\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  padding: 2px 8px;\n  border-radius: 20px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.impersonation-banner__divider {\n  width: 1px;\n  height: 16px;\n  background: rgba(255, 255, 255, 0.35);\n  flex-shrink: 0;\n}\n\n.impersonation-banner__eye {\n  color: rgba(255, 255, 255, 0.85);\n  flex-shrink: 0;\n}\n\n.impersonation-banner__label {\n  color: #fff;\n  font-size: 13px;\n  font-weight: 400;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.impersonation-banner__name {\n  font-weight: 700;\n  color: #fef3c7;\n}\n\n.impersonation-banner__note {\n  color: rgba(255, 255, 255, 0.75);\n  font-size: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.impersonation-banner__back-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(255, 255, 255, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.45);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 5px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n  transition: background 0.15s ease, transform 0.1s ease;\n}\n\n.impersonation-banner__back-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.28);\n  transform: translateY(-1px);\n}\n\n.impersonation-banner__back-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.impersonation-banner__back-btn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n/* Mobile: hide the note text */\n@media (max-width: 640px) {\n  .impersonation-banner__note {\n    display: none;\n  }\n  .impersonation-banner__back-btn span {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
